import { doc, getDoc } from 'firebase/firestore';
import { create } from 'zustand';
import { firestore } from '../../../shared/config/firebase';

export interface OcdTheme {
  key: string;
  friendlyName: string;
  order: number;
}

export interface OcdThemesData {
  ocd_themes: OcdTheme[];
}

export interface OnboardingOcdThemesState {
  ocdThemes: OcdTheme[];
  init: () => Promise<void>;
  getOcdThemes: (keys: string[]) => OcdTheme[];
}

const initialState = {
  ocdThemes: [],
};

export const useOnboardingOcdThemesStore = create<OnboardingOcdThemesState>()((set, get) => ({
  ...initialState,
  init: async () => {
    const currentState = get();
    if (currentState.ocdThemes.length > 0) {
      return;
    }
    const docRef = doc(firestore, 'metadata', 'ocd_themes');
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data() as OcdThemesData;
      const sortedOcdThemes = data.ocd_themes.sort((a, b) => a.order - b.order);
      set({ ocdThemes: sortedOcdThemes });
    }
  },
  getOcdThemes: (keys: string[]) => {
    const currentState = get();
    return currentState.ocdThemes.filter((theme) => keys.includes(theme.key));
  },
}));
